module.exports = __webpack_public_path__ + "img/VectorNew.cbf492a6.svg";